import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Logged Out Homepage Campaign
 */
export const FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603 = experiment({
  name: "FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-09-14",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
